import React from "react";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { siteInfo } from "../mock";

const TopBar = () => {
  return (
    <div className="hidden md:block bg-teal-500 text-neutral-900">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between text-xs font-medium">
        <div className="flex items-center gap-6">
          <a href={`tel:${siteInfo.phone}`} className="flex items-center gap-2 hover:text-white transition-colors">
            <Phone className="w-3.5 h-3.5" /> {siteInfo.phone}
          </a>
          <a href={`mailto:${siteInfo.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
            <Mail className="w-3.5 h-3.5" /> {siteInfo.email}
          </a>
          <span className="flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" /> Ecospace Business Park, Newtown, WB
          </span>
        </div>
        <div className="flex items-center gap-3">
          <a href="#" aria-label="Facebook" className="hover:text-white transition-colors"><Facebook className="w-4 h-4" /></a>
          <a href="#" aria-label="Instagram" className="hover:text-white transition-colors"><Instagram className="w-4 h-4" /></a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
